export const projectionSection = {
  label: '05 / COMPONENTE INSTITUCIONAL',
  title: 'Líneas de proyección',
  description: 'Tres áreas que articulan nuestra experiencia, infraestructura y compromiso con el desarrollo regional.',
};

export const projections = [
  {
    number: '01',
    title: 'Primera línea de proyección',
    content:
      'Servicio de Televisión por Cable: Conectividad a través de Fibra Óptica: Brindamos a nuestros asociados acceso a una red de cable convergente, capaz de transmitir múltiples formatos de información, incluyendo señal de televisión analógica, digital y servicios adicionales. Nuestra parrilla de programación ofrece más de 80 canales de diversas temáticas y géneros, pensada para satisfacer las necesidades de información, educación y entretenimiento de nuestros usuarios. El servicio está disponible mediante un aporte mensual por parte de los asociados, en cumplimiento con la normativa vigente.',
  },
  {
    number: '02',
    title: 'Segunda línea de proyección',
    content:
      'Conectividad a través de Fibra Óptica: Mediante el despliegue de modernas redes de fibra óptica en el municipio, transportamos datos de forma eficiente y ofrecemos servicios de conectividad de banda ancha con altos estándares de calidad. Esta infraestructura nos permite proyectar y desarrollar soluciones tecnológicas alineadas con los desafíos y oportunidades de la Cuarta Revolución Industrial, facilitando el acceso a nuevas aplicaciones, servicios inteligentes y avances en transformación digital.',
  },
  {
    number: '03',
    title: 'Tercera línea de proyección',
    content:
      'Producción Audiovisual Comunitaria – CAPSOS TV: A través del canal de producción propia CAPSOS TV, promovemos espacios de comunicación que reflejan la identidad cultural, la historia y la vida cotidiana de Santa Rosa de Osos. Este medio comunitario fortalece la memoria audiovisual del municipio, da voz a sus habitantes y fomenta la participación ciudadana. Con contenidos locales, CAPSOS TV actúa como una alternativa a los medios masivos, impulsando el desarrollo desde una perspectiva comunitaria.',
  },
];
